import React from 'react';
import CoWorkingLandingPage from '../components/CoWorkingLandingPage';

const Home: React.FC = () => {
    return (
        <CoWorkingLandingPage />
    );
};

export default Home;
